import { render, staticRenderFns } from "./SubHeader.vue?vue&type=template&id=6594c98a&scoped=true&functional=true&"
var script = {}
import style0 from "./SubHeader.vue?vue&type=style&index=0&id=6594c98a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "6594c98a",
  null
  
)

export default component.exports